















































import Button from '@/app/ui/components/Button/index.vue'
import DateTimePickerV2, {
  IDateRangeValue,
} from '@/app/ui/components/DateTimePickerV2/index.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import CloseLine from '@/app/ui/assets/close_line.vue'
import PickupController from '@/app/ui/controllers/PickupController'
import { Utils } from '@/app/infrastructures/misc'
import dayjs from 'dayjs'
import { ExportPickupRequest } from '@/data/payload/api/PickupRequest'
import { FlagsAccount } from '@/feature-flags'

@Component({
  components: {
    Modal,
    DateTimePickerV2,
    Button,
    CloseLine,
  },
})
export default class ModalExportCRRNFD extends Vue {
  @Prop({ default: false }) visible!: boolean

  controller = PickupController

  dateRange = <IDateRangeValue>{
    start: null,
    end: null,
  }

  get isMyWhitelist() {
    return FlagsAccount.pickup_dashboard_liberta_my_whitelist.isEnabled();
  }

  public get decideDisableExportCRRNFDButton(): boolean {
    return (
      this.controller.isExportCRRNFDLoading ||
      (!this.dateRange?.start || !this.dateRange?.end)
    )
  }

  public async exportCRRNFD(): Promise<void> {
    const payload = {
      file_name: `CRRNFD-${Utils.formatDateWithIDLocale(
        dayjs(),
        'YYYYMMDDHHmss'
      )}`,
      dateFrom: Utils.formatDateWithIDLocale(
        <string>this.dateRange?.start?.toISOString(),
        'YYYY-MM-DD'
      ),
      dateTo: Utils.formatDateWithIDLocale(
        <string>this.dateRange?.end?.toISOString(),
        'YYYY-MM-DD'
      ),
      originCountry: this.isMyWhitelist ? 'Malaysia' : ''
    }

    this.controller.setExportCRRNFDLoading(true);
    await this.controller.getExportPickup(new ExportPickupRequest({
      statusId: "CRRNFD",
      route: "/pickup-crrnfd/export",
      payload: Utils.toInstance(new Map(), JSON.stringify(payload), 'snake_case')
    })).finally(() => {
      this.controller.setExportCRRNFDLoading(false);
    })
    this.resetValue();
    this.$emit("cancel");
  }

  public resetValue(): void {
    this.dateRange = {
      end: null,
      start: null,
    }
  }

  @Watch('controller.isSuccessExportCRRNFD')
  onSuccessExportCRRNFD(data: boolean) {
    if (data) {
      this.resetValue()
      this.$emit('cancel')
    }
  }
}
